document.addEventListener('DOMContentLoaded', function () {
  const removeButtons = document.querySelectorAll('.remove-item');

  removeButtons.forEach((button) => {
    button.addEventListener('click', function () {
      const lineItemContainer = this.closest('.cart-grid');
      const itemKey = this.dataset.itemKey;
      const currency = this.dataset.currencySymbol;

      // Add loading state
      lineItemContainer.style.opacity = '0.5';
      button.disabled = true;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: itemKey,
          quantity: 0,
        }),
      })
        .then((response) => response.json())
        .then((cart) => {
          // Remove the item from DOM with a fade out
          lineItemContainer.style.transition = 'opacity 0.3s ease';
          lineItemContainer.style.opacity = '0';

          setTimeout(() => {
            lineItemContainer.remove();

            // If cart is empty, show empty message
            if (cart.item_count === 0) {
              const emptyMessage = document.querySelector('.cart__warnings');
              if (emptyMessage) {
                emptyMessage.classList.remove('dn');
              }
            }

            // Update cart total
            const cartTotal = document.getElementById('cart-total');
            if (cartTotal) {
              cartTotal.innerText = currency + parseFloat((cart.total_price / 100).toFixed(2)).toLocaleString();
            }
          }, 300);
        })
        .catch((error) => {
          console.error('Error:', error);
          lineItemContainer.style.opacity = '1';
          button.disabled = false;
          alert('Could not remove item. Please try again.');
        });
    });
  });
});
